<template>
  <div class="card">
    <div class="box">
      <img
        src="../../../../assets/images/score/scoreCard.png"
        height="auto"
        width="100%"
      />
      <img
        class="coin"
        src="../../../../assets/images/score/coin.png"
        height="457"
        width="456"
      />
      <div class="content">
        <div class="myScore">
          <img
            src="../../../../assets/images/score/base.png"
            style="height: 12px; width: 12px; margin-right: 3px"
          />
          <p>{{ lang('我的积分') }}</p>
        </div>
        <p class="scoreNum">{{ totalPoints }}</p>
        <div class="scoreType">
          <div>
            <p class="name">{{ lang('赠送积分') }}</p>
            <p class="value">{{ bonusPoints || 0 }}</p>
          </div>
          <div>
            <p class="name">{{ lang('充值积分') }}</p>
            <p class="value">{{ score }}</p>
          </div>
        </div>
        <div class="records">
          <div>
            <img
              src="../../../../assets/images/score/collect.png"
              style="height: 14px; width: 14px; margin-right: 3px"
            />
            <p @click="click(1)">{{ lang('充值记录') }}</p>
          </div>
          <p>|</p>
          <div>
            <img
              src="../../../../assets/images/score/change.png"
              style="height: 14px; width: 14px; margin-right: 3px"
            />
            <p @click="click(0)">{{ lang('兑换记录') }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="line">
      <div class="left">
        <img src="../../../../assets/images/score/light.png" />
        <p>{{ lang('充值积分可兑换物料') }}</p>
      </div>
      <div class="right" @click="goCharge">
        <p>{{ lang('积分充值') }}</p>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import lang from '@/langs'
const router = useRouter()

const props = defineProps<{
  score: number
  totalPoints: number
  bonusPoints: number
}>()
const score = ref(props.score)
const totalPoints = ref(props.totalPoints)
const bonusPoints = ref(props.bonusPoints)

watch(
  () => [props.score, props.totalPoints, props.bonusPoints],
  (newValue, oldValue) => {
    // newValue 和 oldValue 都是包含三个元素的数组
    score.value = newValue[0]
    totalPoints.value = newValue[1]
    bonusPoints.value = newValue[2]
  }
)
const emits = defineEmits(['click'])
const click = (value: number) => {
  emits('click', value)
}
const goCharge = () => {
  router.push({
    path: '/scoreCharge',
    query: { isH5: 'true' }
  })
}
</script>

<style scoped lang="less">
.card {
  .box {
    display: flex;
    position: relative;
    > img {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    .coin {
      width: 163px;
      height: 163px;
      right: -10px;
      top: -20px;
    }
    .content {
      position: relative;
      z-index: 2;
      width: 100%;
      padding: 32px 18px 21px 18px;
      color: #fff;
      .records {
        display: flex;
        flex-direction: row;
        > div {
          flex: 2;
          font-size: 13px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
        }
      }
      .myScore {
        margin-bottom: 9px;
        font-size: 13px;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .scoreNum {
        font-size: 25px;
        margin-bottom: 8px;
      }
      .scoreType {
        display: flex;
        flex-direction: row;
        margin-bottom: 12px;
        > div {
          margin-right: 18px;
          > p {
            margin-bottom: 8px;
          }
          .name {
            font-size: 10px;
          }
          .value {
            font-size: 12px;
            font-weight: bold;
          }
        }
      }
    }
  }
  .line {
    background: linear-gradient(
      90deg,
      rgba(60, 61, 85, 1),
      rgba(55, 63, 85, 1)
    ); /* 从左到右的渐变 */
    //height: 44px;
    width: 100%;
    border-radius: 5px;
    margin-top: -10px;
    padding: 22px 12px 12px 12px;
    display: flex;
    justify-content: space-between;
    .left {
      > img {
        width: 18px;
        height: 18px;
        margin-right: 12px;
      }
      > p {
        color: rgba(255, 241, 207, 1);
        font-size: 12px;
      }
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .right {
      background: linear-gradient(
        90deg,
        rgba(241, 235, 208, 1),
        rgba(236, 222, 189, 1)
      ); /* 从左到右的渐变 */
      border-radius: 12px;
      padding: 5px 9px;
      font-size: 10px;
      font-weight: bold;
      color: rgba(59, 62, 85, 1);
    }
  }
}
</style>
